import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseVO } from "../base.vo";
import {
  accountIdentity,
  conf2CustomerLogin,
  conf2AccountFirstName,
  conf2AccountId,
  conf2AccountLastNameNullable,
  identityAccountId,
  conf2AccountType,
  conf2ChatSessionId
} from "../../schema";
import { AccountMethods } from "../../const";
import {
  AccountIdentity,
  Conf2CustomerLogin,
  Conf2AccountFirstName,
  Conf2AccountId,
  Conf2AccountLastNameNullable,
  IdentityAccountId,
  Conf2AccountType,
  Conf2ChatSessionId
} from "../../interface";

export class Conf2AccountJwtVO extends BaseVO<Conf2AccountJwtVORaw> {
  private static validation = JsonSchemaValidator.compile(
    Conf2AccountJwtVO.validationSchema()
  );

  constructor(value: Conf2AccountJwtVORaw) {
    super(JsonSchemaValidator.assert(Conf2AccountJwtVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [
        "id",
        "method",
        "identity",
        "firstName",
        "accountId",
        "accountLogin",
        "type"
      ],
      properties: {
        id: conf2AccountId,
        method: {
          enum: [AccountMethods.Conf2]
        },
        identity: accountIdentity,
        firstName: conf2AccountFirstName,
        lastName: conf2AccountLastNameNullable,
        accountId: identityAccountId,
        accountLogin: conf2CustomerLogin,
        type: conf2AccountType,
        // The LiveE session the token is bound to (YOUM-267); absent from
        // tokens signed before
        conf2ChatSessionId
      }
    };
  }
}

interface Conf2AccountJwtVORaw {
  id: Conf2AccountId;
  method: typeof AccountMethods.Conf2;
  identity: AccountIdentity;
  firstName: Conf2AccountFirstName;
  lastName?: Conf2AccountLastNameNullable;
  accountId: IdentityAccountId;
  accountLogin: Conf2CustomerLogin;
  type: Conf2AccountType;
  conf2ChatSessionId?: Conf2ChatSessionId;
}
